<template>
<div class="deliverable-listing">

	<b-modal size="xl" hide-footer id="editDeliverableModal" title="" class="modal-edit-deliverable"
		@hide="editDeliverableModalHidden">
		<EditModal :allContacts="allContacts" ref="refEditModal" :namespace="namespace" :tabIndex="tabIndex" />
	</b-modal>

	<b-modal id="deleteDeliverableTemplateConfirmModal" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveDeliverableTemplate"
		@cancel="onCancelRemoveDeliverableTemplate" ok-title="Yes, Delete">
		<p>Are you sure you want to delete <strong>{{showRemoveDeliverableTemplateTitle}}</strong> deliverable template?</p>
	</b-modal>


	<div class="deliverable-header">
		<HeaderIcon
			:totalDeliverableCount="this.allDeliverableTemplatesPaginationData.total ? this.allDeliverableTemplatesPaginationData.total : 0"
			:totalOutletCount="this.outletCount ? this.outletCount : 0" :namespace="namespace" />
		
		<!-- Expand / Collapse all button from the header -->
		<span class="d-inline-block float-right pt-15 mr-3 expand-all-area">
			<div v-if="$router.currentRoute.name != 'globalSearch' && $router.currentRoute.name != 'calendar'"
				class="ml-2 expand-grp cursor-pointer" @click="toggleStatusView(!expandAll)">
				<b-button class="header-filter-btns expand-ctrls" :class="{ 'none-active-btn': expandAll }"
					variant="theme" v-b-tooltip.hover title="Expand">
					<span class="text">Expand All </span>
					<span class="icon"><i class="fas text-primary fa-expand fa-fw"></i></span>
				</b-button>
				<b-button class="header-filter-btns expand-ctrls" :class="{ 'none-active-btn': !expandAll }"
					variant="theme" v-b-tooltip.hover title="Collapse">
					<span class="text">Collapse All</span>
					<span class="icon"><i class="fas text-primary fa-compress fa-fw"></i></span>
				</b-button>
			</div>
		</span>
	</div>
	<!-- Start Dashboard Deliverable Loop -->
	<div class="deliverable-block"
		v-for="(deliverableTemplate, index) in deliverableTemplatesArray" v-if="index != 'totalOutlets'"
		:class="(!userAbilities.editMediaCall || (deliverableTemplate && deliverableTemplate.permissions && deliverableTemplate.permissions.viewOnly)) ? 'read-only' : ''"
		:key="'deliverableTemplate' + index">
		<div class="delv-block-resp parent-project-on-hold">
			<!-- <DuplicateMediaCallBtn :deliverableId='deliverableTemplate.id' :namespace="namespace" -->
				<!-- :deliverableTemplateId="deliverableTemplate.id" /> -->
			<div class="d-flex flex-row dbox-wrapper">
				<div class="dbox-left-side dleft-inner-wrap">

					<!-- START Social Top Row -->
					<div class="top-row" v-if="isSocialMedia(deliverableTemplate)">
						<div class="data-items">
							<span>
								{{ deliverableTemplate.title }}
							</span>
						</div>
						<div class="data-items deliverable-project">
							<DeliverableProjects :deliverable="deliverableTemplate" :namespace="namespace" v-if="false"/>
							NO PROJECT
						</div>
						<!-- <div class="data-items hide-mobile social-series"
							v-if="deliverableTemplate.social_series.length > 0">
							<span class="department-label">SERIES: </span>
							<span class="department-title">{{ getSeriesNameByDeliverable(deliverableTemplate) }}</span>
						</div> -->
						<div class="data-items hide-mobile">
							<span>POST DATE:</span>
							<!-- <span class="post-date-value">{# displaySocialPublishDate(deliverableTemplate.publish_date)
							}}</span> -->
						</div>
						<div class="data-items social-status hide-mobile">
							<span>STATUS</span>
						</div>
					</div>
					<!-- END Social Top Row -->

					<div class="top-row" v-else>
							<div class="data-items">
								<span>
									{{ deliverableTemplate.title }}
								</span>
							</div>
						<template>
							<div class="data-items hide-mobile">
								<DeliverableProjects :deliverable="deliverableTemplate" :namespace="namespace" v-if="false"/>
								NO PROJECT
							</div>
							<div class="data-items hide-mobile" v-if="hasPriorityField(deliverableTemplate)">
								<span class="">PRIORITY: </span>
								<span v-b-tooltip.hover title="Priority" class="listing-priority"
									@click="setPriority(deliverable, false)"
									:class="'listing-priority-del-' + deliverableTemplate.id">
									<vue-star-rate
										:rateRange="deliverableTemplate.priority ? Number(deliverableTemplate.priority) : 0"
										:maxIcon="5" :iconHeight="17" :iconWidth="17" :hasCounter="false"
										:key="'del-rating-' + Math.random() + deliverableTemplate.id" iconColor="#ffffff"
										iconColorHover="#ffffff" iconShape="circle"></vue-star-rate>
								</span>
							</div>
							<template v-if="showAltStartEndDate(deliverableTemplate)">
								<div class="data-items hide-mobile">
									<span class="">START DATE:</span>
									<template v-if="calculateStartDate(deliverableTemplate)">
										{{ calculateStartDate(deliverableTemplate) | moment("DD MMM, YYYY") }}
									</template>
									<template v-else>
										No Date
									</template>
								</div>

								<div class="data-items hide-mobile">
									<span class="">END DATE:</span>
									<template v-if="calculateEndDate(deliverableTemplate)">
										{{ calculateEndDate(deliverableTemplate) | moment("DD MMM, YYYY") }}
									</template>
									<template v-else>
										No Date
									</template>
								</div>
							</template>
							<template v-else>
								<div class="data-items hide-mobile">
									<span class="">STARTED:</span>
									{{ deliverableTemplate.created_at | moment("DD MMM, YYYY @ H:mm") }}
								</div>
								<div v-if="deliverableTemplate.all_completed" class="data-items hide-mobile">
									<span class="">COMPLETED:</span>
									{{ deliverableTemplate.completed_at | moment("DD MMM, YYYY @ H:mm") }}
								</div>
								<div v-else class="data-items hide-mobile">
									<span class="">LAST MODIFIED:</span>
									{{ deliverableTemplate.updated_at | moment("DD MMM, YYYY @ H:mm") }}
								</div>
							</template>
						</template>
					</div>
					<DeliverableTypeIcon 
					:deliverableTypeId="deliverableTemplate.id"
					:deliverableProject="deliverableTemplate.project_id" />
					<div class="row mobile-deli-info">
						<div class="data-items deliverable-priority" v-if="hasPriorityField(deliverableTemplate)">
							<span class="text-primary">PRIORITY: </span>
							<span v-b-tooltip.hover title="Priority" class="listing-priority" @click="setPriority(deliverable, true)" :class="'listing-priority-del-'+deliverableTemplate.id">
								<vue-star-rate
									:rateRange="deliverableTemplate.priority ? Number(deliverableTemplate.priority) : 0"
									:maxIcon="5"
									:iconHeight="17"
									:iconWidth="17"
									:hasCounter="false"
									:key="'del-rating-'+Math.random()+deliverableTemplate.id"
									iconColor="var(--wf-primary)"
									iconColorHover="var(--wf-primary)"
									iconShape="circle"
								></vue-star-rate>
							</span>
						</div>
						<template v-if="showAltStartEndDate(deliverableTemplate)">
							<div class="data-items deliverable-start"
								v-for="(field, index) in _.filter(deliverableTemplate.customFields, { field_key: 'start_date' })"
								:key="index">
								<span class="text-primary">START DATE:</span>
								{{ field.value | moment("DD MMM, YYYY") }}
							</div>
							<div class="data-items deliverable-start"
								v-if="_.filter(deliverableTemplate.customFields, { field_key: 'start_date' }).length == 0">
								<span class="text-primary">START DATE:</span>
								No Date
							</div>
							<div class="data-items deliverable-end">
								<span class="text-primary">END DATE:</span>
								<template v-if="calculateEndDate(deliverableTemplate)">
									{{ calculateEndDate(deliverableTemplate) | moment("DD MMM, YYYY") }}
								</template>
								<template v-else>
									No Date
								</template>
							</div>
						</template>
						<template v-else>
							<div class="data-items">
								<span class="text-primary deliverable-start">STARTED:</span>
								{{ deliverableTemplate.created_at | moment("DD MMM, YYYY @ H:mm") }}
							</div>
							<div v-if="deliverableTemplate.all_completed" class="data-items deliverable-completed">
								<span class="text-primary">COMPLETED:</span>
								{{ deliverableTemplate.completed_at | moment("DD MMM, YYYY @ H:mm") }}
							</div>
							<div v-else class="data-items deliverable-last-mod">
								<span class="text-primary">LAST MODIFIED:</span>
								{{ deliverableTemplate.updated_at | moment("DD MMM, YYYY @ H:mm") }}
							</div>
						</template>
						<!-- <div class="data-items no-padding deliverable-tags">
							<DeliverableListTags class="deliverable-list-tags" :deliverable="deliverableTemplate"
								:namespace="namespace" @tag-created="updateDeliverableTags" />
						</div> -->
						<div class="data-items deliverable-project">
							<DeliverableProjects :deliverable="deliverableTemplate" :namespace="namespace" />
						</div>
					</div>
					<div class="row listing-row">
						<div :class="` ${deliverableTemplate.total_unread_messages_in_conversation > 0 ? 'col-md-7' : 'col-md-8 titles '} breakpoint__fix ${isSocialMedia(deliverableTemplate) ? 'social-titles' : ''}`" :style="infoColStyle(deliverableTemplate)">
							<div class="inside-list department--wrap--new" v-if="showDepartment(deliverableTemplate)">
								<DeliverableDepartments :deliverable="deliverableTemplate" :namespace="namespace" />
							</div>
							<div :class="`deliverable-title edit-d-title ${showDepartment(deliverableTemplate) ? '' : 'no-depart'}`"
								@click="showModalFn(deliverableTemplate, false)">
								{{ deliverableTemplate.default_title }}
							</div>
							<div class="mobile-task-expand-button-area">
								<div class="mobile-task-exp-btn">
									<CollapseTaskBtn :deliverable="deliverableTemplate" :index="index"
										:expandAll="expandAll" :namespace="namespace" />
								</div>
							</div>
							<div v-b-tooltip.hover title="Delete" v-if="userCanEditDeliverable() && deliverableTemplate.can_delete"
								@click.stop="deleteDeliverableTemplateClick(deliverableTemplate)"
								:class="`delete-bar ${deliverableTemplate.id == stripRemoveDeliverableTemplateId ? 'hovered' : ''}`"
								v-click-outside="deleteDeliverableTemplateClickOutside(deliverableTemplate.id)">
								<span><i class="fas fa-trash"></i></span>
							</div>
						</div>
						<div v-if="!isMobile() && isSocialMedia(deliverableTemplate)" class="col-md-4 infos publish-status">
							<div class="d-flex flex-row" :style="getPublishStatusStyle(deliverableTemplate.publish_status)">
								<PublishStatusListLabel :deliverable="deliverableTemplate" :namespace="namespace" />
							</div>
						</div>
						<div 
							v-if="!isMobile() &&
							!isSocialMedia(deliverableTemplate) &&
							getSystemSetting('is_chat_enabled') &&
							deliverableTemplate.total_unread_messages_in_conversation > 0" 
							class="col-md-1 infos titles" 
							@click="showModalFn(deliverableTemplate, true)">
							<div class="d-flex flex-row">
								<ListMessageCounter :deliverable="deliverableTemplate" />
							</div>
						</div>
						<div v-if="!isMobile() && !isSocialMedia(deliverableTemplate)" class="col-md-4 infos">

							<div class="d-flex flex-row">
								<DeliverableListCoordinators 
									v-if="showInfoCol(deliverableTemplate) && getSystemSetting('media_call__show_owner')"
									class="deliverable-list-coordinators" :deliverable="deliverableTemplate"
									:namespace="namespace" />

								<DeliverableListContacts v-if="showInfoCol(deliverableTemplate)"
									class="deliverable-list-contacts" :deliverable="deliverableTemplate"
									:namespace="namespace" />

								<!-- <DeliverableListTags class="deliverable-list-tags" :deliverable="deliverableTemplate"
									:namespace="namespace" @tag-created="updateDeliverableTags" /> -->

								<DeliverableStatusOverview :deliverable="deliverableTemplate" :namespace="namespace" />
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<div>
								<b-collapse :visible="expandAll" :id="'task-listing-collapse-' + index">
									<div v-if="isMobile()" class="col-md-6 infos responsive-infos">
										<div class="d-flex flex-row">
										</div>
									</div>
									<TaskFieldLabels :fullDeliverables="deliverableTemplatesArray"
										:tasks="deliverableTemplate.tasks" :deliverableId="deliverableTemplate.id"
										:deliverable="deliverableTemplate" :namespace="namespace" />
									<TaskFields :fullDeliverables="deliverableTemplatesArray" :deliverable="deliverableTemplate"
										:deliverableId="deliverableTemplate.id" :myWeek="false" :tasks="deliverableTemplate.tasks"
										:users="deliverableTemplate.users" :namespace="namespace" />
								</b-collapse>
							</div>
						</div>
					</div>
				</div>
				<div class="dbox-right-side dright-inner-wrap">
					<CollapseTaskBtn :deliverable="deliverableTemplate" :expandAll="expandAll" :index="index"
						:namespace="namespace" />
				</div>
			</div>
		</div>
	</div>
	<!-- End Dashboard Deliverable Loop -->

	<div class="pagination-wrapper">
		<pagination :data="allDeliverableTemplatesPaginationData" @pagination-change-page="onChangePage"
			:limit="isMobile() ? 3 : 5" :size="isMobile() ? 'small' : 'default'"></pagination>
	</div>

</div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import EditModal from "../deliverableTemplates/EditModal";
import HeaderIcon from './HeaderIcon';
// import DeliverableListTags from "./DeliverableListTags";
import DeliverableProjects from "../deliverables/DeliverableProjects";
// import SocialDeliverableCampaigns from "../deliverables/SocialDeliverableCampaigns";
import DeliverableDepartments from "../deliverables/DeliverableDepartments";
import DeliverableDropdown from "../deliverables/DeliverableDropdown";
import DeliverableListContacts from "../deliverables/DeliverableListContacts";
import DeliverableListCoordinators from "../deliverables/DeliverableListCoordinators";
// import TaskCompletionGraph from "../deliverables/TaskCompletionGraph";
import DeliverableTypeIcon from '../deliverables/DeliverableTypeIcon';
// import DeliverableDatesRibbon from "../deliverables/DeliverableDatesRibbon";
// import DeliverableCustomFields from '../common/DeliverableCustomField';
import DeliverableStatusOverview from '../deliverables/DeliverableStatusOverview';
import DuplicateMediaCallBtn from "../common/DuplicateMediaCallBtn";
import CollapseTaskBtn from "../deliverables/CollapseTaskBtn";
import TaskFields from "./TaskFields";
import TaskFieldLabels from "../deliverables/TaskFieldLabels";
import PublishStatusListLabel from "../deliverables/PublishStatusListLabel";
import vueStarRate from "vue-js-star-rating";

export default {
	props: ["filterQuery", "expandAll", "namespace"],
	data() {
		return {
			tabIndex: 0,
			stripRemoveDeliverableTemplateId: null,
			showRemoveDeliverableTemplateTitle: null,
		}
	},
	components: {
		HeaderIcon,
		CollapseTaskBtn,
		// DeliverableListTags,
		DeliverableProjects,
		// SocialDeliverableCampaigns,
		DeliverableStatusOverview,
		DeliverableDepartments,
		DeliverableDropdown,
		DeliverableListContacts,
		DeliverableListCoordinators,
		// TaskCompletionGraph,
		DeliverableTypeIcon,
		DuplicateMediaCallBtn,
		// DeliverableDatesRibbon,
		// DeliverableCustomFields,
		EditModal,
		PublishStatusListLabel,
		TaskFields,
		TaskFieldLabels,
		vueStarRate
	},
	mounted() {
		this.getDeliverableTemplates();
		let that = this;
		this.$root.$on('bv::modal::hide', function (bvEvent, modalId) {
			if (modalId == "editDeliverableModal") {
				this.$store.state.deliverableTemplates.editDeliverableModal = false;
			}
		});
		
		this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
			if (modalId == "editDeliverableModal") {
				this.$store.state.deliverableTemplates.editDeliverableModal = true;
			}
		});
		const isNewRoute = this.$router.currentRoute.name === 'deliverableTemplateNew';
		
		if (isNewRoute) {
			const deliverableTemplateId = this.$router.currentRoute.params.deliverableTemplateId;
			if (deliverableTemplateId) {
				this.setDataLoading(true);
				this.$store
					.dispatch(this.namespace + "getDeliverableTemplateDetail", { deliverableTemplateId })
					.then(() => {
						this.$bvModal.show("editDeliverableModal");
						this.$nextTick(() => {
							$(".edit-deliverableTemplate-modal .deliverableTemplate-title").trigger("click");
						});
						this.setDataLoading(false);
					});
			}
		} else if (this.$router.currentRoute.params.deliverableTemplateId) {
			const deliverableTemplateId = this.$router.currentRoute.params.deliverableTemplateId;
			if (deliverableTemplateId) {
				this.setDataLoading(true);
				this.$store
					.dispatch(this.namespace + "getDeliverableTemplateDetail", { deliverableTemplateId })
					.then(() => {
						this.$bvModal.show("editDeliverableModal");
						this.setDataLoading(false);
					});
			}
		}
	},
	computed: {
		...mapGetters([
			// "dataLoading",
			"userAbilities",
			"getSystemSetting",
			// "currentFieldKey",
		]),
		...mapState({
			allContacts (state, getters) {
			  return getters[this.namespace + 'allContacts']
			},
			allDeliverableTemplates (state, getters) {
			  return getters[this.namespace + 'allDeliverableTemplates']
			},
			deliverableTemplates (state, getters) {
			  return getters[this.namespace + 'deliverableTemplates']
			},
			allDeliverableTemplatesPaginationData (state, getters) {
			  return getters[this.namespace + 'allDeliverableTemplatesPaginationData']
			},
			deliverableTemplateDetail (state, getters) {
			  return getters[this.namespace + 'deliverableTemplateDetail']
			},
			getDeliverableTemplateSlug (state, getters) {
			  return getters['getDeliverableTemplateSlug']
			},
			outletCount (state, getters) {
			  return getters[this.namespace + 'outletCount']
			}
		}),
		deliverableTemplatesArray() {

			return this.deliverableTemplates;
		},
		_() {
			return _;
		},
	},
	methods: {
		...mapMutations({
		  setDataLoading (commit, payload) {
		    return commit(this.namespace + 'setDataLoading', payload)
		  },
		}),
		...mapActions({
			getDeliverableTemplates (dispatch, payload) {
		    return dispatch(this.namespace + 'getDeliverableTemplates', payload)
		  },
		  fetchDeliverableTemplates (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchDeliverableTemplates', payload)
		  },
		  fetchDeliverableTemplateCount (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchDeliverableTemplateCount', payload)
		  },
		}),
		editDeliverableModalHidden() {
			this.$store.commit(this.namespace + 'setDeliverableTemplate', this.deliverableTemplateDetail)
			const currentRoute = this.$router.currentRoute.name;
			const isNewRoute = currentRoute === 'deliverableTemplateNew';
			const isDetailRoute = currentRoute === 'deliverableTemplateDetail';
			this.setDataLoading(true);
			this.$store.dispatch(this.namespace + 'fetchDeliverableTemplateCount');
			this.$store.dispatch(this.namespace + 'fetchDeliverableTemplates').then(() => {
				this.setDataLoading(false);
			});
			
			if (isNewRoute || isDetailRoute) {
				this.$router.back();
			}
		},
		onChangePage(data) {
			this.setDataLoading(true);
			this.fetchDeliverableCount();
			this.fetchDeliverables(data).then(() => {
				this.setDataLoading(false);
			});
		},
		showModalFn(deliverableTemplate, openToChatTab) {
			this.tabIndex = openToChatTab ? 1 : 0;

			this.$router.push({
				name: 'deliverableTemplateDetail',
				params: {
					deliverableTemplateId: deliverableTemplate.id,
					slug: deliverableTemplate.slug
				}
			}).catch(err => {
				if (err.name !== 'NavigationDuplicated') {
					console.error(err);
				}
			});
		},
		closeTemplateModal() {
			this.$router.back();
		},
		_originalShowModalFn_BACKUP(deliverableTemplate, openToChatTab) {
			this.setDataLoading(true);
			// shows edit deliverableTemplate modal
			let deliverableTemplateId = deliverableTemplate.id;
			let modalId = "editDeliverableModal";
			let template_slug = this.getDeliverableTemplateSlug(parseInt(deliverableTemplate.id));

			if (template_slug == "social-media") {
				modalId = "editSocialModal";
				if(deliverableTemplate.social_series){
					if(deliverableTemplate.social_series.length && !deliverableTemplate.manually_updated_at){
						deliverableTemplateId = this.getSeriesMasterByDeliverable(deliverableTemplate);
					}
				}
			} else {
				// Show Chat in only editDeliverableModal
				const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverableTemplate.id));
				if (
					openToChatTab == true &&
					(
						deliverableTemplateSlug == "marketing-project" ||
						deliverableTemplateSlug == "media-call" ||
						deliverableTemplateSlug == "media-event" ||
						deliverableTemplateSlug == "news-release" ||
						deliverableTemplateSlug == "writing-assignment"
					)
				) {
					// openToChatTab == true, clicked on unread message count chat bubble icon
					// Contact is tab1, Chat is tab2
					this.tabIndex = 1;
				} else {
					this.tabIndex = 0;
				}
			}

			if (template_slug == "organic-social-media-plan") {
				modalId = "editOrganicSocialMediaPlanModal";
				if (deliverableTemplate.social_series) {
					if (deliverableTemplate.social_series.length && !deliverableTemplate.manually_updated_at) {
						deliverableTemplateId = this.getSeriesMasterByDeliverable(deliverableTemplate);
					}
				}
			}

			this.$store
				.dispatch(this.namespace + "getDeliverableTemplateDetail", { deliverableTemplateId })
				.then(() => {
					let currentTitle = document.title.match(/\(\d+\)\s/g);
					if (!currentTitle) {
						document.title = this.deliverableTemplateDetail.title;
					} else {
						document.title = currentTitle[0] + this.deliverableTemplateDetail.title;
					}
					this.$bvModal.show(modalId);
					this.setDataLoading(false);
				});

		},
		deliverableTypeTitle(deliverableTypeId) {
			if (this.allDeliverableTemplates) {
				let typeData = _.filter(this.allDeliverableTemplates, { typeId: deliverableTypeId });
				if (typeData.length > 0) {
					return typeData[0].name;
				}
			}
		},
		hasPriorityField(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.id));
			return deliverableTemplateSlug == "media-call";
		},
		showInfoCol(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.id));
			return deliverableTemplateSlug == "media-call";
		},
		infoColStyle(deliverable) {
			// Unused for now
            const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.id));
			if (deliverableTemplateSlug == "project-deliverable") {
				// return 'min-height:96px';
				return '';
			} else {
				return null;
			}
		},
		showDepartment(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.id));
			return deliverableTemplateSlug != "project-deliverable";
		},
		showAltStartEndDate(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.id));
			return deliverableTemplateSlug != "media-call";
		},

		// Status toggle from the header
		toggleStatusView(expandAll) {
			if (this.isMobile()) {
				if (expandAll) {
					$('.deliverable-status-overview').hide();
					$('.deliverable-dates').css('padding-top', 0);
				} else {
					$('.deliverable-status-overview').show();
					$('.deliverable-dates').css('padding-top', '15px');
				}
			}
			this.$emit("collapseToggleUpdated", expandAll);
		},

		calculateStartDate(deliverable) {
			let latestDueDate = null;

			let start_date = _.filter(deliverable.customFields, { field_key: 'start_date' });
			if (start_date.length > 0) {
				return start_date[0].value;
			}
			let start_datetime = _.filter(deliverable.customFields, { field_key: 'start_datetime' });
			if (start_datetime.length > 0) {
				return start_datetime[0].value;
			}


			if (deliverable.tasks && deliverable.tasks.length > 0) {
				deliverable.tasks.forEach(x => {
					const dueDateField = x.taskFields.filter(y => y.field_key == 'due_date')[0];
					if (dueDateField && dueDateField.value && (!latestDueDate || dueDateField.value < latestDueDate )) latestDueDate = dueDateField.value;
				});
			}

			return latestDueDate;
		},
		calculateEndDate(deliverable) {
			let latestDueDate = null;

			let end_date = _.filter(deliverable.customFields, { field_key: 'end_date' });
			if (end_date.length > 0) {
				return end_date[0].value;
			}
			let end_datetime = _.filter(deliverable.customFields, { field_key: 'end_datetime' });
			if (end_datetime.length > 0) {
				return end_datetime[0].value;
			}
			let publish_datetime = _.filter(deliverable.customFields, { field_key: 'publish_datetime' });
			if (publish_datetime.length > 0) {
				return publish_datetime[0].value;
			}

			if (deliverable.tasks && deliverable.tasks.length > 0) {
				deliverable.tasks.forEach(x => {
					const dueDateField = x.taskFields.filter(y => y.field_key == 'due_date')[0];
					if (dueDateField && dueDateField.value && (!latestDueDate || latestDueDate < dueDateField.value)) latestDueDate = dueDateField.value;
				});
			}

			return latestDueDate;
		},
		userCanEditDeliverable() {
			return (this.userAbilities.deleteMediaCall);
		},
		deleteDeliverableTemplateClick(deliverable) {
			console.log(deliverable);
			if (deliverable.can_delete) {
				// deliverable.deleteClicked = true;
				if (!this.isMobile()) {
					this.showRemoveDeliverableTemplateId = deliverable.id;
					this.showRemoveDeliverableTemplateTitle = deliverable.title;
					this.$bvModal.show("deleteDeliverableTemplateConfirmModal");
				} else {
					if (this.stripRemoveDeliverableTemplateId == null) {
						this.stripRemoveDeliverableTemplateId = deliverable.id;
					} else {
						this.showRemoveDeliverableTemplateId = deliverable.id;
						this.$bvModal.show("deleteDeliverableTemplateConfirmModal");
					}
				}
			}
		},
		deleteDeliverableTemplateClickOutside(deliId) {
			let that = this;
			return () => {
				if (that.stripRemoveDeliverableTemplateId == deliId) {
					that.stripRemoveDeliverableTemplateId = null;
				}
			}
		},

		onConfirmRemoveDeliverableTemplate() {
			if (this.showRemoveDeliverableTemplateId) {
				let that = this;
				this.$store.dispatch(this.namespace + "removeDeliverableTemplate", { id: this.showRemoveDeliverableTemplateId }).then(function (response) {
					that.$bvModal.hide("deleteDeliverableTemplateConfirmModal");
					that.showRemoveDeliverableTemplateId = null;
					if (response && response?.status && response?.status != 200) {
						return;
					}
				});
			}
		},
		onCancelRemoveDeliverableTemplate() {
			this.showRemoveDeliverableTemplateId = null;
		},



		getSeriesMasterByDeliverable(deliverable) {
			if (typeof deliverable.social_series_deliverables != "undefined") {
				let series = deliverable.social_series_deliverables;
				if (series.length) {
					let master = series.find(x => x.is_master === 1);
					if (master) {
						return master.id;
					}
				}
			}
			return false;
		},
		getSeriesNameByDeliverable(deliverable) {
			if (this.allSocialSeries.length && deliverable.social_series.length) {
				let series = this.allSocialSeries.find(x => x.id === deliverable.social_series[0]);
				if (series) {
					return series.name;
				}
			}
			return "None";
		},
		// displaySocialPublishDate(publishDate) {
		// 	if (publishDate) {
		// 		return this.$moment.utc(publishDate).local().format("DD MMM, YYYY");
		// 	}
		// 	return "NO DATE SET";
		// },
		getPublishStatusStyle(publish_status) {
			if (publish_status) {
				var status = JSON.parse(publish_status);
				return "background-color:" + status.color;
			}
		},
		// updateDeliverableTags(updatedDeliverableId) {
		// 	let deliverableToUpdate;
		// 	if (this.deliverablesArray instanceof Array) {
		// 		deliverableToUpdate = this.deliverablesArray.find(x => x.id == updatedDeliverableId);
		// 	} else {
		// 		for (let i of Object.keys(this.deliverablesArray)) {
		// 			deliverableToUpdate = this.deliverablesArray[i].find(x => x.id == updatedDeliverableId);
		// 			if (deliverableToUpdate != null) break;
		// 		}
		// 	}
		// 	if (deliverableToUpdate != null) {
		// 		deliverableToUpdate.tags = this.deliverableTemplateDetail.tags;
		// 	} else {
		// 		console.error(`List Deliverable with ID ${updatedDeliverableId} not found.`);
		// 	}
		// },
		// isParentProjectOnHold(project_id) {
		// 	if (
		// 		project_id &&
		// 		project_id.project_status &&
		// 		project_id.project_status.slug &&
		// 		project_id.project_status.slug == 'on-hold'
		// 	) {
		// 		return true;
		// 	}
		// 	return false;
		// },
		isSocialMedia(deliverable) {
			if (parseInt(deliverable.id) === parseInt(process.env.MIX_APP_DELIVERABLE_TEMPLATE_SOCIAL_MEDIA)) {
				return true;
			}
			return false;
		},
		// applyBackgroundColorIfOnHold(project_id) {
		// 	if (
		// 		project_id &&
		// 		project_id.project_status &&
		// 		project_id.project_status.color &&
		// 		project_id.project_status.slug &&
		// 		project_id.project_status.slug == 'on-hold'
		// 	) {
		// 		return { backgroundColor: project_id.project_status.color };
		// 	}
		// 	return {};
		// },
	},
	watch: {
		'$route': function (to, from) {
			if (to.name === 'deliverableTemplateDetail' || to.name === 'deliverableTemplateNew') {
				const id = to.params.deliverableTemplateId;
				if (!id) return;

				if (
					!this.deliverableTemplateDetail ||
					this.deliverableTemplateDetail.id != id
				) {
					this.setDataLoading(true);
					this.$store
						.dispatch(this.namespace + 'getDeliverableTemplateDetail', {
							deliverableTemplateId: id
						})
						.then(() => {
							this.$bvModal.show('editDeliverableModal');
							this.setDataLoading(false);
						});
				} else {
					this.$bvModal.show('editDeliverableModal');
				}
			}

			if (
				(from.name === 'deliverableTemplateDetail' || 
				from.name === 'deliverableTemplateNew') &&
				to.name === 'deliverable-templates'
			) {
				this.$bvModal.hide('editDeliverableModal');
				if (window.location.hash) {
					history.replaceState(null, null, window.location.pathname + window.location.search);
				}
			}
		},
		deliverableTemplateDetail: {
			handler: function (newVal, oldVal) {
				if (newVal && newVal.title) {
					document.title = newVal.title;
				}
				if (newVal && newVal.id) {
					const deliverableTemplateToUpdate = this.deliverableTemplatesArray.find(x => x.id == newVal.id);
					if (deliverableTemplateToUpdate) {
						Object.assign(deliverableTemplateToUpdate, newVal);
					}
				}
			},
			deep: true
		}
	}
}

</script>

<style scoped>
.deliverable-block  .top-row {
	background-color:var(--wf-primary);
	color:var(--wf-secondary);
}

.drag-handle {
	width:2rem;
}
</style>